<template>
    <div class="creditCardPaymentWrapper" id="credit-card-payment">
        <vue-loading :active="isLoading" :is-full-page="true" />
    </div>
</template>

<script>
import VueLoading from 'vue-loading-overlay'
import {paymentService} from "@/services/api/paymentService";
import {PaymentProviders} from "@/constants/constants";

export default {
    data(){
      return {
          externalUrl : "",
          isLoading: false,
      }
    },
    methods: {
      async loadSecurepay() {
        this.isLoading = true;
        const result = await paymentService.initPayment(PaymentProviders.SECUREPAY);

        if (result.errorCode < 0) {
          this.makeToast('danger', result.errorMsg);
          return;
        }

        this.externalUrl = result.redirectURL;
        this.openExternalUrl();

        this.isLoading = false;
      },
      openExternalUrl() {
        if (this.externalUrl) {
          window.open(this.externalUrl, '_self');
        }
      }
    },
    components:{
      VueLoading,
    },
    mounted() {
      this.loadSecurepay();
    }
}
</script>

<style>

</style>
